import { Box, Paper, Stack } from "@mui/material";
import QueryPreservingLink from "../../components/QueryPreservingLink";
import { map } from "lodash";
import React from "react";

const Sidebar = ({ popularTags, categories, className }) => {
  return (
    <Paper
      sx={{
        borderRadius: "10px",
        boxShadow: "-10px 11.1px 50px 0 rgba(188, 198, 210, 0.33)",
        padding: "45.8px 28px 40px",
        minWidth: "235px",
        flexShrink: 0,
      }}
      className={className}
    >
      <Box
        sx={{
          fontSize: "18px",
          fontWeight: "bold",
          lineHeight: 0.98,
          color: "#2a149a",
          marginBottom: "13.3px",
        }}
      >
        Popular Tags
      </Box>

      <Stack
        direction={{ xs: "row", lg: "column" }}
        sx={{
          marginBottom: "39px",
          alignItems: "start",
          flexWrap: { xs: "wrap", lg: "nowrap" },
        }}
      >
        {map(popularTags, ({ node: { id, name, slug } }) => (
          <Stack
            component={QueryPreservingLink}
            key={`category-${id}`}
            to={`/blog/tag/${slug}`}
            sx={{
              marginRight: "8px",
              marginBottom: "6px",
              borderRadius: "5px",
              padding: "2px 28.8px 2.8px 20.1px",
              textDecoration: "none",
              justifyContent: "center",
              alignItems: "center",
              height: "23px",
              color: "#626972",
              fontSize: "14px",
              backgroundColor: "rgba(162, 170, 181, 0.35)",
              fontWeight: "normal",
              lineHeight: 0.6,
            }}
          >
            {name}
          </Stack>
        ))}
      </Stack>

      <Box
        sx={{
          fontSize: "18px",
          fontWeight: "bold",
          lineHeight: 0.98,
          color: "#2a149a",
          marginBottom: "13.3px",
        }}
      >
        Categories
      </Box>

      {map(categories, ({ node: { id, name, slug, count } }) => (
        <Stack
          component={QueryPreservingLink}
          key={id}
          to={`/blog/category/${slug}`}
          sx={{
            textDecoration: "none",
          }}
        >
          <Box
            sx={{
              color: "#2b2a29",
              fontSize: "14px",
              lineHeight: 1.91,
            }}
          >{`${name} (${count})`}</Box>
        </Stack>
      ))}
    </Paper>
  );
};

export default Sidebar;
